import { Tooltip } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConversationMedia, getNextConversationMedia } from '../../../../actions/conversations';
import SideBarTab from '../../../../common/SideBarTabs';
import { getFileType, getKeyNameForMediaList, getLookupWitHDefaultValue } from '../../../../utils/common';
import { SkeltonCardTwo } from '../../../../common/SkeltonCardTwo';
import { textCss } from '../../../../common/Css';
import Loader from '../../../../common/Loader';
import { openMediaViewModal } from '../../../../actions/modal';
import ApprovedRejectIcon from '../../components/ApprovedRejectIcon';
import { showApprovalOptionsinMedia } from '../../ChatController';
import Checkbox from '../../../../common/Checkbox';
import IconToolTip from '../../../../common/IconToolTip';
import { getChatMedia } from '../../../../actions/chat';
import useHeicImage from '../../../../hooks/useHeicImage';

const media = {
    tabName: 'Media',
    tabID: 'media',
    category: 'images',
};
const docs = {
    tabName: 'Docs',
    tabID: 'docs',
    category: 'docs',
};
const tabs = [media, docs];

const transformMediaList = ({ mediaList, openTab }) => {
    let dateWiseList = {};
    if (Array.isArray(mediaList)) {
        mediaList.forEach((file, index) => {
            let key = getKeyNameForMediaList(file.created_at || Date.now());
            if (dateWiseList[key] !== undefined) {
                dateWiseList[key].push({ ...file, index });
            } else {
                dateWiseList[key] = [{ ...file, index }];
            }
        });
    }
    return dateWiseList;
};

export const getMediaType = (openTab) => {
    return openTab === 'media' ? 'MEDIA' : 'DOCS';
};

export const GroupMedia = ({ openedConversationId }) => {
    const chatMedia = useSelector((state) => state.chat.chatMedia);
    const defaultOpenTab = (tabs) => tabs[0].tabID;
    const [openTab, setOpenTab] = useState(defaultOpenTab(tabs));
    const { conversationDetails } = useSelector((state) => state.conversations);
    const openedConversation = conversationDetails?.[openedConversationId];
    const isChatMediaLoading = useSelector((state) => state.loading.isChatMediaLoading);
    const isNextChatMediaLoading = useSelector((state) => state.loading.isNextChatMediaLoading);
    const [page, setPage] = useState(1);

    const mediaList = useMemo(() => {
        return chatMedia?.[`${openedConversationId}-${getMediaType(openTab)}`] || [];
    }, [chatMedia, openedConversationId, openTab]);

    const [warning, setWarning] = useState(false);
    const dispatch = useDispatch();

    // useEffect(() => {
    //     if (checkedTracker) {
    //         if (selectedMedia?.length === 10) {
    //             setWarning(true);
    //         } else {
    //             setWarning(false);
    //         }
    //     }
    // }, [checkedTracker, selectedMedia?.length]);

    const handleOnChangeCheckbox = (position) => {
        // if (checkedTracker.has(position)) {
        //     setCheckedTracker((prev) => {
        //         const next = new Set(prev);
        //         next.delete(position);
        //         return next;
        //     });
        // } else {
        //     setCheckedTracker((prev) => new Set(prev).add(position));
        // }
    };

    const filesList = transformMediaList({ mediaList, openTab, openedConversationId });

    const getGroupMedia = useCallback(({ openTab, limit = 25, page = 1, id }) => {
        dispatch(getChatMedia({ id, type: getMediaType(openTab), limit, page }));
    }, [dispatch]);

    useEffect(() => {
        getGroupMedia({ openTab, limit: 10, page: 1, id: openedConversationId });
    }, [openTab, getGroupMedia, openedConversationId]);

    const handleScroll = (event) => {
        const bottom = Math.abs(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight);
        if (bottom <= 1 && !isChatMediaLoading && !isNextChatMediaLoading) {
            getGroupMedia({ openTab, limit: 10, page: page + 1, id: openedConversationId });
            setPage(page + 1);
        }
    };

    const renderMedia = () => {
        if (isChatMediaLoading) {
            return (
                <div className='px-6'>
                    <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7]} height={15} />
                </div>
            );
        } else if (filesList && Object.keys(filesList).length > 0) {
            return (
                <>
                    {warning && (
                        <div className='absolute w-full bg-warning flex justify-between items-center text-font13 py-2 px-3 rounded-md top-0 shadow-md z-10'>
                            <span className='font-medium flex items-center'>
                                <span className='material-icons mr-2 text-font16'>warning</span>
                                You can only share 10 attachments.
                            </span>
                            <IconToolTip title="Close" onClick={() => setWarning(false)}>
                                <span className='text-scogoprimary hover:text-scogoorange cursor-pointer material-icons text-font18'>
                                    close
                                </span>
                            </IconToolTip>
                        </div>
                    )}
                    {Object.entries(filesList).map(([key, value], sectionIndex) => (
                        <div key={`section-${sectionIndex}`} className='px-4 mb-6'>
                            <p className='font-medium text-font14 text-scogoprimary pt-2 pb-3 border-b border-gray-100'>
                                {key}
                            </p>
                            <div className='mt-3'>
                                <Files
                                    list={value}
                                    openedConversationId={openedConversationId}
                                    openedConversationType={openedConversation?.type}
                                    handleOnChangeCheckbox={handleOnChangeCheckbox}
                                    // checkedTracker={checkedTracker}
                                    // disableClick={selectedMedia?.length === 10}
                                    setWarning={setWarning}
                                />
                            </div>
                        </div>
                    ))}
                    {isNextChatMediaLoading && (
                        <div className='absolute bottom-0 left-0 right-0 flex justify-center'>
                            <Loader color='#F48A21' size='20' speed='1' thickness='3' margin='10px' />
                        </div>
                    )}
                </>
            );
        }
        return (
            <div className='mx-4 my-4 py-4 flex items-center justify-center rounded-lg bg-red-50 border border-red-200'>
                <div className='text-center'>
                    <span className='material-icons text-red-500 text-3xl mb-2'>image_not_supported</span>
                    <p className='text-red-700 font-medium'>No Media Found</p>
                </div>
            </div>
        );
    };

    return (
        <div className='flex flex-col h-full'>
            <div className='border-b border-gray-200 bg-white'>
                <div className='flex w-full items-center'>
                    <SideBarTab
                        tabs={tabs}
                        openTab={openTab}
                        setOpenTab={setOpenTab}
                        tabClass='text-font13 font-medium px-5 py-3 block leading-normal hover:text-scogoorange cursor-pointer w-6/12 transition-colors duration-200'
                    />
                </div>
            </div>

            <div className='bg-white overflow-y-auto groupDetailsMediaHeight py-3 relative flex-grow' onScroll={handleScroll}>
                {renderMedia()}
            </div>
        </div>
    );
};

const Files = ({ list, openedConversationType, openedConversationId, handleOnChangeCheckbox, checkedTracker, disableClick, setWarning }) => {
    const mediaFileType = getLookupWitHDefaultValue({
        lookup: {
            audio: '/img/audio.png',
            video: '/img/video.png',
            pdf: '/img/pdf.png',
            file: '/img/file.png',
            others: '/img/unknownFileType.png',
            xls: '/img/xls.png',
            text: '/img/txt-file.png',
        },
        defaultValue: '/img/unknownFileType.png',
    });

    const dispatch = useDispatch();

    return (
        <div className='grid grid-cols-3 gap-4'>
            {list.map((item, index) => {
                let isSelected = checkedTracker?.has(item?.id);
                const showApprovalOptions = showApprovalOptionsinMedia({
                    conversationType: openedConversationType,
                    isApproved: item?.isApproved,
                });

                return (
                    <Tooltip key={item.id || index} title={item.name} placement="top">
                        <div className={`relative group ${disableClick && !isSelected ? "opacity-60" : ""}`}>
                            {/* <div
                                className='absolute top-2 left-2 z-10 cursor-pointer bg-white bg-opacity-80 rounded-full p-0.5 transition-opacity duration-200'
                                onClick={() => {
                                    if (disableClick && !isSelected) {
                                        setWarning(true);
                                    } else {
                                        handleOnChangeCheckbox(item?.id);
                                    }
                                }}
                            >
                                <Checkbox
                                    checkColor='text-whatsappGreen'
                                    checked={checkedTracker.has(item?.id)}
                                    dynamicSize={"1.5rem"}
                                    onChange={() => { }}
                                />
                            </div> */}

                            {item.is_duplicate && (
                                <div className='absolute top-2 left-2 z-10 bg-red-500 text-white text-xs px-2 py-1 rounded-md'>
                                    Duplicate
                                </div>
                            )}

                            {getFileType(item.mime_type) === 'image' ? (
                                <ImageWithHeic item={item} list={list} index={index} dispatch={dispatch} />
                            ) : (
                                <div
                                    className='w-full h-40 rounded-lg hover:border-scogoorange border-transparent border-2 flex items-center justify-center cursor-pointer bg-gray-50 transition-all duration-300 hover:shadow-md'
                                    onClick={() => {
                                        dispatch(openMediaViewModal({ attachments: list, openedMediaIndex: index }));
                                    }}
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + (mediaFileType[item.mime_type] || mediaFileType.others)}
                                        className='w-20 h-20 object-contain'
                                        alt={item.mime_type || 'File'}
                                    />
                                </div>
                            )}

                            {/* {item?.mime_type === 'image' && (
                                <div className='absolute flex gap-2 right-2 bottom-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200'>
                                    <ApprovedRejectIcon
                                        showApprovalOptions={showApprovalOptions}
                                        isApproved={item?.isApproved}
                                        approver={item?.approver}
                                        rejecter={item?.rejecter}
                                        conversationId={openedConversationId}
                                        messageId={item?.message?._id}
                                        attachmentId={item?._id}
                                    />
                                </div>
                            )} */}

                            <div className='absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white text-xs p-1.5 opacity-0 group-hover:opacity-100 transition-opacity truncate rounded-b-lg'>
                                {item.name}
                            </div>
                        </div>
                    </Tooltip>
                );
            })}
        </div>
    );
};

const ImageWithHeic = ({ item, list, index, dispatch }) => {
    return (
        <div
            className='overflow-hidden rounded-lg shadow-sm transition-all duration-300 hover:shadow-md cursor-pointer'
            onClick={() => {
                dispatch(openMediaViewModal({ attachments: list, openedMediaIndex: index }));
            }}
        >
            <ThumbnailWithHeicForGrid url={item.thumbnail_url} mimeType={item.mime_type} name={item.name} />
        </div>
    );
};

const ThumbnailWithHeicForGrid = ({ url, mimeType, name }) => {
    const { src: renderSrc, isConverting } = useHeicImage(url, mimeType);

    return (
        <div className="relative h-40 w-full">
            {renderSrc && !isConverting && <img
                src={renderSrc}
                className='w-full h-full object-cover rounded-lg hover:border-scogoorange border-transparent border-2 transition-all duration-300'
                alt={name || 'Media'}
            />}
            {isConverting && (
                <div className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 text-white text-xs'>
                    <span className='material-icons text-sm animate-spin'>refresh</span>
                </div>
            )}
        </div>
    );
};
